import { setAppErrors } from '../../action/system'
import { retrieveErrorFromApi } from '../../../helper'
import getCompanyActivationData from '../../axios/registration/company/activationData/get'
import { setCompanyRegistrationData } from '../../action/company'

export const getCompanyRegistrationDataThunk = () => async (dispatch) => {
	try {
		const activationDataRes = await getCompanyActivationData()
		dispatch(setCompanyRegistrationData({ ...activationDataRes.data }))
	} catch (error) {
		dispatch(setAppErrors(retrieveErrorFromApi(error)))
	}
}
